import CustomVOptionSet from "./customVOptionSet";
import {RegexHelper} from "../../../helpers/regexHelper";
import {PermitteeType} from "../../../enums/permitteeType";
import {TagColor} from "../../../enums/tagColor";

export default class EmailVOptionSet extends CustomVOptionSet<{id: string}> {
  valueKey: 'id' = 'id';
  optionType = PermitteeType.email;
  showWhenEmpty = false;
  selectedColor = TagColor[PermitteeType.email];

  search(q: string): Promise<{}> {
    if (q.match(RegexHelper.emailOrBlank)) {
      this.options = [{label: q, id: q, optionType: this.optionType}];
      return Promise.resolve(this.options);
    } else {
      this.options = [];
      return Promise.resolve([]);
    }
  }
}